module.exports = __webpack_public_path__ + "img/jacket-left-sub-raglan-zipper.2ed2353b.png";